export type RegionConfig = {
  mode: "allowlist" | "blocklist";
  countries?: string[];
  stateOverrides?: {
    [countryCode: string]: {
      mode: "allowlist" | "blocklist";
      states: string[];
    };
  };
};

export const isRegionAllowed = (
  config: RegionConfig,
  country: string,
  state?: string
): boolean => {
  const { mode, countries = [], stateOverrides = {} } = config;
  const isCountryAllowlist = mode === "allowlist";

  // Check if country is in the list
  const countryListed = countries.includes(country);
  const countryAllowed = isCountryAllowlist ? countryListed : !countryListed;

  if (!countryAllowed) {
    return false;
  }

  // Check state overrides if state is provided
  if (state && stateOverrides[country]) {
    const { mode: stateMode, states } = stateOverrides[country];
    const stateListed = states.includes(state);
    return stateMode === "allowlist" ? stateListed : !stateListed;
  }

  return true;
};
